import SvgIcon from "../../../Components/Common/Component/SvgIcon";

const Searchbar = () => {
  const SeacrhResposive = () => {
    const isOpened = !!document.querySelector(".search-full open");
    if (!isOpened) {
      document.querySelector(".search-full")?.classList.add("open");
    } else {
      document.querySelector(".search-full")?.classList.remove("open");
    }
  };

  return (
    <li onClick={() => SeacrhResposive()}>
      <span className="header-search">
        <SvgIcon iconId="search" />
      </span>
    </li>
  );
};

export default Searchbar;
